function s(num, val) {
    amount = num * 1; // amount is the num or NaN
    sum = (!num ? 0 : num) * val; // the sum for that bill or coin

    if (isNaN(amount)) { // if the entire is not a number
        alert("' " + num + " ' is not a valid entry and that field will " +
            "not be included in the total money calculation.");
        return 0;
    } else
        return sum; // if it is OK, send sum back
}

function moneySum(form) {
    hun = s(form.hun.value, 100); // Each amount is the returned value
    fif = s(form.fif.value, 50); // for the amount in the s() function
    twe = s(form.twe.value, 20);
    ten = s(form.ten.value, 10);
    fiv = s(form.fiv.value, 5);
    one = s(form.one.value, 1);
    hlf = s(form.hlf.value, .5);
    qtr = s(form.qtr.value, .25);
    dme = s(form.dme.value, .1);
    nck = s(form.nck.value, .05);
    pny = s(form.pny.value, .01);

    // add up all the amounts
    var ttl = hun + fif + twe + ten + fiv +
        one + hlf + qtr + dme + nck + pny;

    // rounds total to two decimal places

    ttl = "" + ((Math.round(ttl * 100)) / 100);

    dec1 = ttl.substring(ttl.length - 3, ttl.length - 2);
    dec2 = ttl.substring(ttl.length - 2, ttl.length - 1);

    if (dec1 != '.') { // adds trailing zeroes if necessary
        if (dec2 == '.') ttl += "0";
        else ttl += ".00";
    }
    form.total.value = "$ " + ttl; // display total amount
}

let calculateStyles = `<style>
input[type="button"].calc-button {
    text-align: center;
	font-family: Verdana, sans-serif;   
    background: #063d6e!important;
    color: #fff;
    padding: 15px 0px;
    font-size: 17px;
    text-transform: inherit;
	display:block;
    width: 100%;
    margin-bottom: 15px;
}
input[type="button"].calc-button:hover {
    cursor: pointer;
}
table.resp-tab {
    border-radius: 5px;
    font-weight: normal;
    border: none;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
}
table.resp-tab th, table.resp-tab td {
    padding: 10px 20px;
    font-size: 17px;
    border: none;
    font-family: Verdana, sans-serif;   
    border: 0px solid #063d6e;
    vertical-align: top;
}
table.resp-tab th {
    color: #FFF;
    background: #063d6e;
    font-weight: bold;
    border: 0px solid #1a4a73;   
    text-transform: uppercase;   
    text-align: center;   
}
table.resp-tab td span {
    background: #337AB7;
    color: #FFF;
    display: none;
    font-size: 11px;
    font-weight: bold;
    font-family: Verdana, sans-serif;   
    text-transform: uppercase;       
    padding: 5px 10px;
    position: absolute;
    top: 8px;
    left: 20px;   
}
table.resp-tab td input[type="text"] {
    background: #eceff8;
    border: 2px solid #eceff8;
    -webkit-box-shadow: none;
    box-shadow: none;
    padding: 5px 10px;
    font-size: 17px;
    color: #333;
    width: 100%;
    text-align: center;
}
@media(max-width: 768px) {
    table.resp-tab thead {
        display: none;
    }
    table.resp-tab tr {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin-bottom: 30px;
    }
    table.resp-tab td {
        margin: 0 -1px -1px 0;
        padding-top: 35px;
        position: relative;
        width: 50%;
    }
    table.resp-tab td span {
        display: block;
    }
    table.resp-tab td input[type="text"] {
        width: 100%;
    }
}
@media(max-width: 480px) {
    table.resp-tab td {
        width: 100%;
    }
}

.calc-copy{
    margin: 20px auto;
    font-family: Verdana, sans-serif;   
    font-size: 11px;
    text-align: center;
}
.calc-copy a{
    color: #337AB7;
}
</style>`;

let calculateTable = `<form name="coinform">
<table border="1" class="resp-tab">
	<thead>
		<tr>
		<th align="center">$ 100</th>
		<th align="center">$ 50</th>
		<th align="center">$ 20</th>
		<th align="center">$ 10</th>
		<th align="center">$ 5</th>
		<th align="center">$ 1</th>
		</tr>
	</thead>
	<tbody>
		<tr>
		<td align="center"><span>$ 100</span><input type="text" name="hun" size="3" /></td>
		<td align="center"><span>$ 50</span><input type="text" name="fif" size="3" /></td>
		<td align="center"><span>$ 20</span><input type="text" name="twe" size="3" /></td>
		<td align="center"><span>$ 10</span><input type="text" name="ten" size="3" /></td>
		<td align="center"><span>$ 5</span><input type="text" name="fiv" size="3" /></td>
		<td align="center"><span>$ 1</span><input type="text" name="one" size="3" /></td>
		</tr>
	</tbody>
</table>

<table border="1" class="resp-tab">
	<thead>
		<tr>
		<th align="center">50 ¢</th>
		<th align="center">25 ¢</th>
		<th align="center">10 ¢</th>
		<th align="center">5 ¢</th>
		<th align="center">1 ¢</th>
		</tr>
	</thead>
	<tbody>
		<tr>
		<td align="center"><span>50 ¢</span><input type="text" name="hlf" size="3" /></td>
		<td align="center"><span>25 ¢</span><input type="text" name="qtr" size="3" /></td>
		<td align="center"><span>10 ¢</span><input type="text" name="dme" size="3" /></td>
		<td align="center"><span>5 ¢</span><input type="text" name="nck" size="3" /></td>
		<td align="center"><span>1 ¢</span><input type="text" name="pny" size="3" /></td>
		</tr>
		<tr>
			<td colspan="5" align="center">
				<input type="button" name="calc" value="Calculate" onclick="javascript:moneySum(this.form)" class="calc-button" /> 
				<input type="text" name="total" size="10" />
			</td>
		</tr>
	</tbody>
</table>
</form>

<div class="calc-copy">Powered by <a href="https://carnation-inc.com/" target="_blank">Carnation-Inc</a></div>`;


let calcRoot = document.getElementById('currencyCalculator');


if (calcRoot){
	document.head.insertAdjacentHTML("beforeend", calculateStyles);
	calcRoot.insertAdjacentHTML("beforeend", calculateTable);
}